import { environ } from "@ihr-radioedit/sdk-utils";
import { PWSMediaService } from "@inferno/renderer-shared-core";

export const coastMediaService = new PWSMediaService("coast-pr", environ.dep("pws"));
